import { AppTranslation } from '@/libs/i18n/interface';

import bi from './bi';
import mka from './mka';
import segment from './segment';
import component from './component';
import communication from './communication';
import authentication from './authentication';
import permission from './permission';
import exportReport from './export';
import myAccount from './my-account';
import notification from './notification';
import dataRelation from './data-relation';
import dataConnector from './data_connector';
import datepicker from './datepicker';
import customerInsight from './customer-insight';

export default <AppTranslation>{
  noti_exporter_account: 'บัญชีผู้ส่งออกแจ้งเตือน',
  noti_category: 'หมวดหมู่',
  noti_coupon_all: 'รับการแจ้งเตือนจากเหตุการณ์สำคัญในหมวดหมู่คูปองทั้งหมด',
  noti_credit_all: 'รับการแจ้งเตือนจากเหตุการณ์สำคัญในหมวดหมู่เครดิตทั้งหมด',
  noti_campaign_all: 'รับการแจ้งเตือนจากเหตุการณ์สำคัญในหมวดหมู่แคมเปญทั้งหมด',
  coupon_dynamic: 'ไม่สามารถเปิดการแจ้งเตือนได้',
  coupon_dynamic_detail: 'เนื่องจากเป็นคูปองรูปแบบคงที่',
  coupon_low: 'คูปองใกล้หมด',
  coupon_low_des: 'แจ้งเตือนเมื่อคูปองคงเหลือในระบบมีจำนวนต่ำกว่าที่กำหนด',
  coupon_remaining: 'จำนวนคูปองคงเหลือ',
  coupon_remaining_des: 'จำนวนคูปองคงเหลือ',
  coupon_expiring: 'คูปองใกล้หมดอายุ',
  coupon_expiring_des: 'แจ้งเตือนเมื่อแคมเปญคูปองถึงวันที่ใกล้สิ้นสุดตามที่กำหนด',
  notify_within: 'แจ้งเตือนภายใน',
  credit_low: 'เครดิตใกล้หมด',
  credit_low_des: 'แจ้งเตือนเมื่อจำนวนเครดิตคงเหลือในระบบมีจำนวนต่ำกว่าที่กำหนด',
  credit_empty: 'เครดิตหมด',
  credit_empty_des: 'แจ้งเตือนเมื่อเครดิตไม่เพียงพอสำหรับส่งออกแคมเปญการสื่อสารได้',
  credit_remaining: 'จำนวนเครดิตคงเหลือ',
  credit_topup: 'เติมเครดิตสำเร็จ',
  credit_topup_des: 'แจ้งเตือนเมื่อเติมเครดิตเข้า ChocoCDP สู่ระบบเรียบร้อย',
  campaign_low: 'แคมเปญใกล้สิ้นสุด',
  campaign_low_des: 'แจ้งเตือนเมื่อแคมเปญใกล้ถึงวันสิ้นสุดตามที่กำหนด',
  campaign_end: 'สิ้นสุดแคมเปญ',
  campaign_end_des: 'แจ้งเตือนเมื่อแคมเปญการตลาดอัตโนมัติสิ้นสุดลงตามที่กำหนด',
  campaign_remaining: 'ระยะเวลาแคมเปญคงเหลือ',
  campaign_time: 'เวลาส่งออกแจ้งเตือน',
  add_contact: 'เพิ่มผู้ติดต่อ',
  add_username: 'เพิ่มชื่อผู้ใช้งานที่ต้องการรับแจ้งเตือนจากระบบ ChocoCDP',
  username: 'ชื่อผู้ใช้งาน',
  noti_contact: 'รายชื่อผู้ติดต่อ',
  noti_contact_detail: 'รายชื่อผู้ใช้งานทั้งหมดที่มีสิทธิ์รับการแจ้งเตือนจากระบบ ChocoCDP',
  move_segment: 'ย้ายกลุ่มเป้าหมาย',
  color_swatches: 'ตัวอย่างสี',
  simple: 'ปกติ',
  custom: 'กำหนดเอง',
  advance: 'ขั้นสูง',
  shade: 'ไล่สี',
  random: 'สุ่ม',
  clear_all: 'ล้างค่าทั้งหมด',
  coupon: 'คูปอง',
  credit: 'เครดิต',
  campaign: 'แคมเปญการตลาดอัตโนมัติ',
  coupon_des: 'ตั้งค่าเงื่อนไขการส่งออกแจ้งเตือนหมวดหมู่คูปอง',
  credit_des: 'ตั้งค่าเงื่อนไขการส่งออกแจ้งเตือนหมวดหมู่เครดิต',
  campaign_des: 'ตั้งค่าเงื่อนไขการส่งออกแจ้งเตือนหมวดหมู่แคมเปญ',
  all: 'ทั้งหมด',
  mb: 'แอพ',
  email: 'Email',
  sms: 'SMS',
  noti_add_user: 'เพิ่มผู้ติดต่อ',
  noti_add_user_detail: 'เพิ่มชื่อผู้ใช้งานที่ต้องการรับการแจ้งจากระบบ ChocoCDP',
  confirm_delete_title: 'ต้องการลบ',
  confirm_delete_detail: 'รายชื่อ {fullname} หรือไม่?',
  cancel: 'ยกเลิก',
  next: 'ถัดไป',
  add: 'เพิ่ม',
  confirm: 'ตกลง',
  notification_setting: 'ตั้งค่าการแจ้งเตือน',
  notification_des_setting: 'ตั้งค่าการแจ้งเตือนรายบุคคลเพื่อรับข้อความอัตโนมัติเมื่อมีเหตุการณ์สำคัญในหมวดคูปอง เครดิต และแคมเปญ',
  setting_noti: 'การตั้งการแจ้งเตือน',
  advanced_setting: 'ตั้งค่าขั้นสูง',
  unit: 'จำนวน',
  day: 'วัน',
  time: 'ครั้ง',
  currency: 'สกุลเงิน',
  point: 'พอยท์',
  time_picker: {
    select_time: 'เลือกเวลา',
  },

  date_picker: {
    relative: {
      // -- duration
      day: '{days} วัน | {days} วัน',
      month: '{months} เดือน | {months} เดือน',
      year: '{years} ปี | {years} ปี',
      hour: '{hours} ชั่วโมง | {hours} ชั่วโมง',
      minute: '{minutes} นาที | {minutes} นาที',
      second: '{seconds} วินาที | {seconds} วินาที',
      // --- relative
      today: 'วันนี้',
      // --- custom
      custom: 'กำหนดเอง',
    },
    to: 'ถึง',
    date_range: 'ช่วงวันที่',
    select_date: 'เลือกวันที่',
    start_date: 'วันที่เริ่มต้น',
    end_date: 'วันที่สิ้นสุด',
    apply: 'ตกลง',
    cancel: 'ยกเลิก',
    relative_picker: 'ตัวเลือกวันที่แบบสัมพันธ์',
    last_day: '{num} วันที่ผ่านมา',
    last_month: '{num} เดือนที่ผ่านมา',
    last_year: '{num} ปีที่ผ่านมา',
    last_hour: '{num} ชั่วโมงที่ผ่านมา',
    last_minute: '{num} นาทีที่ผ่านมา',
    last_second: '{num} วินาทีที่ผ่านมา',
  },
  Detail: 'รายละเอียด',
  Segment: 'กลุ่มเป้าหมาย',
  Template: 'เทมเพลต',
  Communication: 'การสื่อสาร​',
  Channel: 'ช่องทาง',
  'Line OA': 'LINE',
  campaign_list: 'รายการแคมเปญ',
  edit_campaign: 'แก้ไขแคมเปญ',
  Campaign: 'แคมเปญ',
  Create: 'สร้าง',
  campaign_info: 'รายละเอียดแคมเปญ',

  auth: {
    btn_login: 'เข้าสู่ระบบ',
    username: 'บัญชีผู้ใช้',
    email_required: 'กรุณาใส่อีเมล',
    username_required: 'กรุณาใส่บัญชีผู้ใช้',
    username_invalid: 'บัญชีผู้ใช้ผิด',
    password: 'รหัสผ่าน',
    password_required: 'กรุณาใส่รหัสผ่าน',
    password_invalid: 'รหัสผ่านผิด',
  },

  main_menu: {
    dashboard: 'แดชบอร์ด',
    analytics: 'การวิเคราะห์ข้อมูล',
    analytics_rfm: 'โมเดล RFM',
    segment: 'กลุ่มเป้าหมาย',
    data_connector: 'แหล่งเชื่อมต่อข้อมูล',
    data_cconnector_overview: 'แหล่งข้อมูล',
    data_connector_data_relationship: 'การจัดการความสัมพันธ์',
    data_connector_coupon: 'คูปอง',
    data_connector_history: 'ประวัติ',
    communication: 'การสื่อสาร',
    communication_all_channel: 'ช่องทางทั้งหมด',
    communication_limitation: 'ข้อจำกัด',
    automation: 'การตลาดอัตโนมัติ',
    setting: 'การตั้งค่า',
  },

  menu_bar: {
    edit_profile: 'ตั้งค่าโปรไฟล์',
    brand_account: 'บัญชีของฉัน',
    change_brand_account: 'เปลี่ยนแบรนด์',
    permission: 'สิทธิการใช้งาน',
    profile: 'โปรไฟล์',
    manage_permission: 'จัดการสิทธิ์การใช้งาน',
    history: 'ประวัติการใช้งาน',
    change_role: 'เปลี่ยนบทบาท',
    manage_storage: 'จัดการที่เก็บข้อมูล',
    configuration: 'กำหนดค่า',
    sign_out: 'ลงชื่อออก',
    change_password: 'เปลี่ยนรหัสผ่าน',
    switchlanguage: 'ภาษา',
    setting_notification: 'ตั้งค่าการแจ้งเตือน',
  },

  change_brand_modal: {
    error: 'เกิดข้อผิดพลาด',
    error_description: 'ไม่สามารถเลือก Brand ได้ในขณะนี้',
    change_brand_account: 'เปลี่ยนแบรนด์',
    select_brand_account: 'เลือกแบรนด์',
    cancel: 'ยกเลิก',
    change: 'เปลี่ยน',
  },

  bi,

  data_connector: {
    // Tab
    tab_data_connector: 'แหล่งเชื่อมต่อข้อมูล​',
    tab_data_source_list: 'เชื่อมต่อข้อมูล',
    tab_add_datasource: 'เพิ่มแหล่งข้อมูล',
    tab_excel_datasource: 'แหล่งข้อมูล Excel/CSV',
    tab_file_history: 'ประวัติการอัพโหลดข้อมูล',
    tab_Setting_fasthelp5_Integration: 'การตั้งค่ารวม Fasthelp5',
    // Page overview
    overview_title: 'ฟังก์ชั่นจัดการเครื่องมือสำหรับนำเข้าและส่งออกข้อมูล', //'ฟังก์ชั่นจัดการเครื่องมือสำหรับนำเข้าและส่งออกข้อมูล เพื่อเพิ่มขีดความสามารถของระบบ CDP'
    overview_btn_connect_datasource: 'เชื่อมข้อมูล',
    overview_data_connector_detail: 'ตอนนี้คุณสามารถเชื่อมต่อปลายทางที่คุณต้องการส่งข้อมูลไป',
    overview_btn_connect_commu: 'จุดหมายปลายทาง​',
    overview_commu_detail: 'เพิ่มปลายทางที่คุณต้องการส่งออกข้อมูลหรือเผยแพร่แคมเปญที่นี่',
    // Page file history
    file_history_column_no: 'ลำดับ',
    file_history_column_ref_code: 'รหัสอ้างอิง',
    file_history_column_type: 'ประเภท',
    file_history_column_name: 'ชื่อ',
    file_history_column_amount: 'อัพโหลดไฟล์',
    file_history_column_last_update: 'แก้ไขล่าสุด',
    file_history_column_status: 'สถานะ',
    // Page datasource
    datasource_header: 'เพิ่มแหล่งข้อมูล',
    datasource_search_text: 'ค้นหา',
    // Page dataset
    dataset_btn_create_template: 'สร้าง',
    // Page create template
    // Page update file
    upload_file_progress_upload: 'อัปโหลด',
    upload_file_progress_confirm_data: 'ยืนยันข้อมูล',
    upload_title_download_template: 'ดาวน์โหลดแบบฟอร์ม​',
    upload_btn_download_template: 'ดาวน์โหลด',
    upload_btn_browse_file: 'อัปโหลดไฟล์',
    upload_backup_file: 'สำรองไฟล์',
    // Page summary upload
    summary_upload_column_status: 'สถานะ',
    summary_upload_column_quantity: 'จำนวน',
    summary_upload_column_row_success: 'สำเร็จ',
    summary_upload_column_row_error: 'เกิดข้อผิดพลาด',
    summary_upload_column_row_total: 'รวม',
    // Page coupon managements
    tab_coupon_management: 'คูปอง',
    tab_coupon_detail: 'รายละเอียด',
    upload_coupon_button: 'อัปโหลดข้อมูลทั้งหมด',
    edit_coupon_button: 'แก้ไขรายละเอียด',
    status_coupon_text: 'สถานะ',
    uploading: 'กำลังอัปโหลด',
    upload_failed: 'อัปโหลดไม่สำเร็จ',
    retry: 'คลิกเพื่อลองอีกครั้ง',
    // Table coupon
    couponId: 'รหัสคูปอง',
    image: 'รูปภาพ',
    campaignName: 'ชื่อแคมเปญ',
    couponName: 'ชื่อคูปอง',
    couponType: 'ประเภทคูปอง',
    trackingCode: 'จำนวนการใช้คูปอง/ ภาพรวมคูปอง',
    source: 'แหล่งข้อมูล',
    format: 'รูปแบบข้อมูล',
    balanceandtotal: 'ยอดคงเหลือ/ยอดรวม',
    balance: 'สมดุล',
    total: 'จำนวนทั้งหมด',
    reference: 'ข้อมูลอ้างอิง',
    lastUpload: 'ข้อมูลอัปเดตล่าสุด',
    updateBy: 'อัปเดตโดย',
    status: 'สถานะ',
    lastUpdate: 'อัปเดตล่าสุด',
    action_edit: 'แก้ไขการกระทำ',
  },

  setting: {
    unauthorized: 'ไม่ได้รับอนุญาต',
    detail_setting: '"คุณต้องได้รับอนุญาตจึงจะดำเนินการนี้ได้" บน Choco CDP',
    cell_us: 'โทร',
    contact: 'ติดต่อ',
  },

  base_table: {
    noItems: 'ไม่มีรายการ',
    loading: 'กำลังโหลด',
  },
  global: {
    view_more: 'ดูเพิ่มเติม',
    loading: 'กำลังโหลด...',
    export: 'ส่งออก',
    cancel: 'ยกเลิก',
    apply: 'นำมาใช้',
    close: 'ปิด',
    confirm: 'ยืนยัน',
    filter: 'ตัวกรอง',
    save: 'บันทึก',
    save_as: 'บันทึกเป็น',
    edit: 'แก้ไข',
    copy: 'คัดลอก',
    delete: 'ลบ',
    try: 'ลองอีกครั้ง',
    no_information: 'ไม่มีข้อมูล',
    error: 'เกิดข้อผิดพลาด',
    back: 'ย้อนกลับ',
    not_dowload_report: 'ไม่สามารถดาวน์โหลด Report ได้',
    confirm_delete: 'ต้องการลบ',
    do_confirm_delete: 'ต้องการลบ {any} หรือไม่?',
    confirm_duplicate: 'ต้องการคัดลอก',
    do_confirm_duplicate: 'ต้องการคัดลอก {any} หรือไม่?',
    confirm_cancel: 'ต้องการยกเลิก',
    do_confirm_cancel: 'ต้องการยกเลิก {any} หรือไม่?',
    successful: 'ทำรายการสำเร็จ',
  },

  component: component,
  segment: segment,
  mka: mka,
  communication: communication,
  authentication: authentication,
  permission: permission,
  account: myAccount,
  notification: notification,
  dataRelation: dataRelation,
  dc: dataConnector,
  exportReport: exportReport,
  // Churn Rate​
  churn_rate: 'อัตราการเลิกเป็นลูกค้า',
  all_segment: 'กลุ่มเป้าหมายทั้งหมด​',
  overview: 'ภาพรวม​',
  data_source: 'แหล่งที่มาทั้งหมด',
  calculate_churn_rate: 'คำนวณอัตราการสูญเสียลูกค้า​',
  overall_churn_rate: 'ภาพรวมคำนวณอัตราการสูญเสียลูกค้า',
  des_overall_churn_rate: 'อัตราการสูญเสียลูกค้า คืออัตราส่วนของลูกค้าทั้งหมดที่ยกเลิกการใข้สินค้าหรือบริการของธุรกิจในช่วงเวลาหนึ่ง',
  select_segment: 'เลือกกลุ่มเป้าหมาย',
  stage: 'สถานะ',
  normal: 'ปกติ',
  risk_churn: 'เสี่ยงสูญเสีย',
  churn: 'สูญเสีย',
  close: 'ปิด',
  // Line Card type
  select_card_type: 'เลือกประเภทการ์ด',
  products: 'สินค้า',
  places: 'สถานที่',
  people: 'บุคคล',
  pictures: 'รูปภาพ',
  summary: 'สรุปรายการ',
  page: 'หน้า',
  type: 'ประเภท',

  number_of_images: 'จำนวนภาพ',
  upload_image: 'อัปโหลดรูปภาพ',
  enter_label_text: 'เพิ่มข้อความป้ายกำกับ',
  header: 'หัวข้อ',
  enter_header: 'เพิ่มหัวข้อ',
  description: 'คำอธิบาย',
  enter_description: 'เพิ่มข้อความอธิบาย',
  price: 'ราคา',
  call_to_action: 'ปุ่มแอกชัน',
  enter_action: 'เพิ่มข้อความ',
  enter_action_label: 'เพิ่มข้อความกำกับปุ่ม',
  address: 'ที่อยู่',
  enter_address_info: 'เพิ่มข้อมูลที่อยู่',
  enter_name: 'เพิ่มชื่อ',
  name: 'ชื่อ',
  additional: 'ข้อมูลเพิ่มเติม',
  enter_additional_type: 'กรุณาเลือก',
  additional_info: 'เพิ่มข้อมูลเพิ่มเติม',
  hours: 'เวลา',
  opening_hours: 'ช่วงเวลา',
  enter_hours: 'เพิ่มเวลา',
  location_info: 'ตำแหน่งที่อยู่',
  after_setting_the_location: 'เมื่อระบุตำแหน่งที่อยุ่แล้ว ผู้ใช้สามารถคลิกหรือแตะที่อยู่บนการ์ดเพื่อเปิดตำแหน่งนั้นบน Google Maps',
  enter_address: 'เพิ่มที่อยู่',
  click_on_map: 'คลิกเพื่อเลือกที่อยู่',
  tag: 'แท็กกำกับ',
  tag1: 'แท็กกำกับ1',
  tag2: 'แท็กกำกับ2',
  tag3: 'แท็กกำกับ3',
  enter_tag: 'เพิ่มข้อความแท็ก',
  crop: 'ครอบตัดรูปภาพ',
  personalized_messages: 'ข้อความเฉพาะบุคคล',
  choose_which_data_fields: 'เลือกฟิลด์ข้อมูลที่จะใช้ส่งข้อความเฉพาะบุคคลให้แต่ละผู้รับ',
  personalized_messages_1: 'ข้อควมเฉพาะบุคคล1',
  personalized_messages_2: 'ข้อควมเฉพาะบุคคล2',
  personalized_messages_3: 'ข้อควมเฉพาะบุคคล3',
  personalized_messages_4: 'ข้อควมเฉพาะบุคคล4',
  personalized_messages_5: 'ข้อควมเฉพาะบุคคล5',
  enter_personalized_data_label: 'ข้อความกำกับข้อมูลเฉพาะบุคคล',
  select_data_to_display: 'เลือกข้อมูลสำหรับแสดง',
  define_placeholder_text: 'กำหนดข้อความแทนค่าว่าง',

  please_enter_template_name: 'กรุณากรอกชื่อเทมเพลต',
  please_enter_a_header: 'กรุณากรอกหัวข้อ',
  please_enter_a_label: 'กรุณากรอกข้อความกำกับ',
  please_enter_a_price: 'กรุณากรอกราคา',
  please_enter_a_url: 'กรุณากรอกลิงก์',
  please_enter_an_address: 'กรุณาเพิ่มที่อยู่',

  use: 'นำไปใช้',
  couponName: 'ชื่อคูปอง',
  start_to_end_date: 'วันเริ่มต้น-สิ้นสุด',
  reference: 'รหัสอ้างอิง',
  all_coupon: 'คูปองทั้งหมด',
  available_coupon: 'พร้อมใช้',
  issued_coupon: 'รับคูปอง',
  issued_expired_coupon: 'หมดเขตรับคูปอง',
  redeemed_coupon: 'ใช้สิทธิ์คูปอง',
  redeem_expired_coupon: 'หมดอายุ',
  no: 'ลำดับ',
  redeem_dt:'วัน-เวลาใช้สิทธิ์',

  lms_tag: 'แท็ก',
  tag_banner: 'แบนเนอร์',
  tag_notification: 'แจ้งเตือน',
  use_type_tag: 'เลือกประเภทแท็ก',
  use_tag: 'เลือกแท็ก',
  use_type_banner: 'เลือกประเภทแบนเนอร์',
  use_banner: 'เลือกรายการแบนเนอร์',
  use_banner_group: 'เลือกกลุ่มแบนเนอร์',
  use_banner_set: 'เลือกชุดแบนเนอร์',
  use_type_notification: 'เลือกประเภทการแจ้งเตือน',
  use_notification: 'เลือกการแจ้งเตือน',
  tag_detail: 'รายการแท็กที่เลือก',
  apply: 'ใช้งาน',
  add_tag: 'เพิ่มแท็ก',
  del_tag: 'ลบแท็ก',
  back: 'ย้อนกลับ',
  save: 'บันทึก',
  campaign_name: 'ชื่อแคมเปญ',
  tag_type: 'ประเภทแท็ก',
  tag_name: 'ชื่อแท็ก',
  created_by: 'สร้างโดย',
  last_date: 'อัปเดตล่าสุด ',
  banner_group: 'ชื่อกลุ่มแบนเนอร์',
  banner_type: 'ประเภทเบนเนอร์',
  banner_name: 'ชื่อแบนเนอร์',
  start_date: 'วันที่เริ่มต้น',
  end_date: 'สิ้นสุด',
  status: 'สถานะ',
  banner_id: 'Banner ID',
  banner_set_id: 'Banner set ID',
  notification_id: 'Notification ID',
  banner_set: 'ชื่อชุดแบนเนอร์',
  notification_text: 'แจ้งเตือน',
  select_notification: 'เลือกประเภทแจ้งเตือน',
  notification_type: 'ประเภทการแจ้งเตือน',
  notification_name: 'ชื่อการแจ้งเตือน',
  all_customer: 'ลูกค้าทั้งหมด',
  success: 'สำเร็จ',
  failed: 'ล้มเหลว ',
  banner_list: 'รายการแบนเนอร์',
  entry: 'รอบการทำงาน',
  times: 'ครั้ง',
  update_time: 'เวลาอัปเดต',
  please_select: 'กรุณาเลือก',
  des_add_tag: 'เพิ่มแท็กเพื่อจัดการกลุ่มเป้าหมายที่หลากหลายมากยิ่งขึ้น',
  confirm_add_tag: 'ต้องการเพิ่มแท็ก {any} หรือไม่',
  title_confirm_del_tag: 'ต้องการลบแท็กหรือไม่',
  confirm_del_tag: 'คุณต้องการลบแท็ก “{any}” \n ออกจากกลุ่มเป้าหมายนี้หรือไม่',
  success_del_tag: 'ลบแท็กสำเร็จ',
  success_add_tag: 'เพิ่มแท็กสำเร็จ',
  datepicker,
  customerInsight,

  // Segment Template

  system_template: 'คลังเทมเพลต',
  add_template: 'เพิ่มเทมเพลต',
  system: 'ระบบ',
  template: 'เทมเพลต',
  my_template: 'เทมเพลตของฉัน',
  show: 'แสดง',
  segment_name: 'ชื่อกลุ่มเป้าหมาย',
  create_segment: 'สร้างกลุ่มเป้าหมาย',
  import_segment: 'นำเข้ากลุ่มเป้าหมาย',
  export_segment: 'ส่งออกกลุ่มเป้าหมาย',
  delete: 'ลบ',
  edit: 'แก้ไข',
  duplicate: 'ทำซ้ำ',
  search: 'ค้นหา',
  filter: 'ตัวกรอง',
  active: 'ใช้งาน',
  inactive: 'ไม่ใช้งาน',
  created_date: 'วันที่สร้าง',
  updated_date: 'วันที่อัปเดต',
  no_data: 'ไม่มีข้อมูล',
  delete_template: 'ลบเทมเพลต “{any}” ',
  confirm_delete: 'ต้องการลบเทมเพลตใช่หรือไม่ ?',
  total: 'ทั้งหมด',
  items: 'รายการ',
  selected: 'เลือกแล้ว',
  segment_detail: 'รายละเอียดกลุ่มเป้าหมาย',
  last_updated_by: 'แก้ไขล่าสุดโดย',
  save_success: 'บันทึกสำเร็จ',
  delete_success: 'ลบเทมเพลตสำเร็จ',
  segment_condition: 'เงื่อนไขกลุ่มเป้าหมาย',
  add_condition: 'เพิ่มเงื่อนไข',
  no_condition: 'ไม่มีเงื่อนไข',
  preview: 'ตัวอย่าง',
  total_customer: 'จำนวนลูกค้าทั้งหมด',
  select_template: 'เลือกเทมเพลต',
  template_name: 'ชื่อเทมเพลต',
  please_input_template_name: 'กรุณากรอกชื่อเทมเพลต',
  please_input_description: 'กรุณากรอกคำอธิบาย',
  template_type: 'ประเภทเทมเพลต',
  group_type: 'กลุ่มเทมเพลต',
  category_type: 'หมวดหมู่เทมเพลต',
  use_template_create_segment: 'ต้องการใช้เทมเพลตนี้สร้างกลุ่มเป้าหมายหรือไม่',
  clear_data_modal: 'ล้างข้อมูล',
  des_clear_data_modal: 'ภายหลังการเปลี่ยนเงื่อนไขของกลุ่มเป้าหมาย เงื่อนไขเดิมจะถูกลบทันที',
  default_button_template: 'คืนค่าเริ่มต้น?',
  des_default_button_template: 'ต้องการการล้างเงื่อนไขทั้งหมดที่ตั้งค่าไว้ และคืนค่าตามเทมเพลตตั้งต้น',
  please_input: 'โปรดกรอกข้อมูล',
  please_input_number: 'กรุณากรอกตัวเลขที่ถูกต้อง',
  please_input_boolean: 'กรุณากรอกค่า 0 หรือ 1 เท่านั้น',
  default: 'ค่าเริ่มต้น',
  create_template: 'สร้างเทมเพลต',
  save_template: 'บันทึกเทมเพลต',
  recommended_aspect_ratio: 'อัตราส่วนภาพที่แนะนำ : {any}',
  supports_pic_files: ' (รองรับไฟล์ JPG, JPEG, PNG ขนาดสูงสุด 10 MB)',
  //RFM
  setting_rfm: 'ตั้งค่า RFM Model',
  des_setting_rfm: 'การกำหนดเกณฑ์การแบ่งช่วงคะแนนในการคำนวณ',
  dashboard: 'แดชบอร์ด',
  rfm_filter: 'ตัวกรอง RFM',
  last_updated: 'อัปเดตล่าสุด',
  add_chart: 'เพิ่มแผนภูมิ',
  customers: 'ลูกค้า',
  spending: 'ช่วงยอดการใช้จ่าย',
  frequency: 'จำนวนการใช้บริการ(ครั้ง)',
  recency: 'ความถี่ใช้บริการครั้งล่าสุดภายใน(วัน)',
  monetary: 'มูลค่าการใช้จ่าย',
  spending_text: 'ยอดการใช้จ่าย',
  frequency_text: 'ความถี่การใช้บริการ',
  recency_text: 'การใช้บริการล่าสุด',
  monetary_text: 'ยอดใช้จ่ายรวม',
  create_rfm_model: 'สร้างโมเดล RFM',
  name_rfm_model: 'ชื่อโมเดล RFM',
  name_model: 'ชื่อโมเดล',
  save_and_apply: 'บันทึกและนำไปใช้',
  rfm_configuration: 'การตั้งค่าการคำนวณ RFM',
  des_rfm_configuration: 'RFM เครื่องมือวิเคราะห์ลูกค้าและแบ่งกลุ่มลูกค้าเชิงพฤติกรรมเชิงลึก',
  calculate_mode: 'โหมดการคำนวณ',
  des_calculate_mode: 'กำหนดวิธีคำนวณและจัดกลุ่มลูกค้าด้วยโมเดล RFM',
  des_modal_rfm: 'RFM เทมเพลตสำหรับใช้วิเคราะห์ลูกค้าและกลุ่มลูกค้าเชิงพฤติกรรมเชิงลึก พร้อมการตั้ง RFM Dashboard',
  segment_group: 'กลุ่มเป้าหมาย',
  updated_by: 'อัปเดตโดย',
  des_delete: 'ต้องการลบโมเดลและการตั้งค่านี้ \n ออกจากระบบหรือไม่',
  successful: 'ทำรายการสำเร็จ',
  des_use: 'ต้องการใช้ {any} \n เป็นเกณฑ์การคำนวณ RFM บนระบบหรือไม่',
  un_use: 'ยกเลิก',
  des_un_use: 'ต้องการยกเลิกการใช้ {any} \n เป็นเกณฑ์การคำนวณ RFM บนระบบหรือไม่',
  rfm_cell: 'ตารางจัดกลุ่มลูกค้า RFM',
  conditions: 'เงื่อนไขแบบ',
  rfm_conditions: 'เงื่อนไข RFM',
  and: 'และ',
  or: 'หรือ',
  select_all: 'เลือกทั้งหมด',
  placeholder_select: 'เลือก...',
  placeholder_score: 'คะแนน',
  rfm_scoring: 'คะแนน R/F/M',
  weighted_score: 'คะแนนถ่วงน้ำหนัก',
  rfm_cell_matrix: 'ตาราง RFM',
  des_rfm_cell_matrix:
    'ตารางแสดง RFM Call ตามโครงสร้างฐานมาตรฐาน 11 กลุ่ม โดยอ้างอิงช่วงคะแนนของ Recency, Frequency และ Monetary เพื่อใช้เป็นกรอบอ้างอิงเดียวกันในการการจัดกลุ่มลูกค้า',
  rfm_matrix: 'ตาราง RFM',
  saveing: 'กำลังบันทึก...',
  basic_setting: 'การตั้งค่าพื้นฐาน',
  weighted_scoring: 'คะแนนถ่วงน้ำหนัก',
  des_weighted_scoring: 'เลือกรูปแบบการคำนวณการถ่วงน้ำหนักคะแนนรวม RFM โดยอ้างอิงช่วงคะแนนของ Recency, Frequency และ Monetary',
  weighted_scoring_mode: 'โหมดคะแนนถ่วงน้ำหนัก',
  customer_distribution_overview: 'ภาพรวมการกระจายตัวของลูกค้า',
  cal_ing: 'กำลังคำนวณข้อมูล...',
  date_range: 'ช่วงวันที่',
  des_date_range: 'การกำหนดช่วงเวลาเพื่อคำนวณค่าสำหรับใช้ในการคำนวณ',
  select_range: 'เลือกช่วงเวลา',
  re_calculate: 'คำนวณค่าใหม่',
  calculate: 'คำนวณค่า',
  noti_recency_block_bill: 'คำนวณจากข้อมูลเข้าใช้บริการล่าสุด โดยคิดจากประวัติการทำรายการธุรกรรมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_frequency_block_bill: 'คำนวณจากจำนวนความถี่การใช้บริการ โดยคิดจากประวัติการทำรายการธุรกรรมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_monetary_block_bill: 'คำนวณจากมูลค่าการใช้บริการ โดยคิดจากประวัติการทำรายการธุรกรรมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_recency_block_point: 'คำนวณจากข้อมูลเข้าใช้งานล่าสุด โดยคิดจากประวัติการทำรายการคะแนนสะสมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_frequency_block_point: 'คำนวณจากจำนวนความถี่การได้รับ - แลกใช้คะแนนสะสม โดยคิดจากประวัติการทำรายการสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_monetary_block_point: ' คำนวณจากมูลค่าคะแนนสะสม โดยคิดจากประวัติการทำรายการสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_recency_block_package: 'คำนวณจากข้อมูลเข้าใช้งานแพ็กเกจครั้งล่าสุด โดยคิดจากประวัติการทำรายการที่มีสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_frequency_block_package: 'คำนวณจากจำนวนความถี่การใช้แพ็กเกจ โดยคิดจากประวัติการทำรายการที่มีสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_monetary_block_package: 'คำนวณจากข้อมูลมูลค่าคะแนนสะสมที่ใช้แลกแพ็กเกจ โดยคิดจากประวัติการใช้งานที่มีสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_recency_block_privilege: 'คำนวณจากข้อมูลเข้าใช้งานล่าสุด โดยคิดจากประวัติการทำรายการสิทธิพิศษสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_frequency_block_privilege: 'คำนวณจากจำนวนความถี่การใช้งาน โดยคิดจากประวัติการทำรายการสิทธิพิศษสะสมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_monetary_block_privilege: 'คำนวณจากข้อมูลมูลค่าคะแนนสะสมที่ใช้แลก โดยคิดจากประวัติการทำรายการสิทธิพิศษสถานะเสร็จสมบูรณ์ทั้งหมด',
  footer_note: 'รูปแบบการคำนวณพื้นฐาน โดยระบบจะแบ่งกลุ่มเป้าหมาย RFM ตามเกณฑ์การจัดกลุ่มมาตรฐาน',
  lookback: '{any} วันล่าสุด',
  custom_lookback: 'กำหนดเอง',
  all_source: 'ข้อมูลทั้งหมด',
  event: 'กิจกรรม',
  operation: 'เงื่อนไข',
  remove_source: 'ลบหล่งข้อมูล',
  add_event: 'เพิ่มกิจกรรม',
  noti_recency_scoring_bill: 'คำนวณจากข้อมูลเข้าใช้บริการล่าสุด โดยคิดจากประวัติการทำรายการธุรกรรมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_frequency_scoring_bill: 'คำนวณจากจำนวนความถี่การใช้บริการ โดยคิดจากประวัติการทำรายการธุรกรรมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_monetary_scoring_bill: 'คำนวณจากมูลค่าการใช้บริการ โดยคิดจากประวัติการทำรายการธุรกรรมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_recency_scoring_point: 'คำนวณจากข้อมูลเข้าใช้งานล่าสุด โดยคิดจากประวัติการทำรายการคะแนนสะสมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_frequency_scoring_point: 'คำนวณจากจำนวนความถี่การได้รับ - แลกใช้คะแนนสะสม โดยคิดจากประวัติการทำรายการสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_monetary_scoring_point: ' คำนวณจากมูลค่าคะแนนสะสม โดยคิดจากประวัติการทำรายการสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_recency_scoring_package: 'คำนวณจากข้อมูลเข้าใช้งานแพ็กเกจครั้งล่าสุด โดยคิดจากประวัติการทำรายการที่มีสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_frequency_scoring_package: 'คำนวณจากจำนวนความถี่การใช้แพ็กเกจ โดยคิดจากประวัติการทำรายการที่มีสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_monetary_scoring_package: 'คำนวณจากข้อมูลมูลค่าคะแนนสะสมที่ใช้แลกแพ็กเกจ โดยคิดจากประวัติการใช้งานที่มีสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_recency_scoring_privilege: 'คำนวณจากข้อมูลเข้าใช้งานล่าสุด โดยคิดจากประวัติการทำรายการสิทธิพิศษสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_frequency_scoring_privilege: 'คำนวณจากจำนวนความถี่การใช้งาน โดยคิดจากประวัติการทำรายการสิทธิพิศษสะสมสถานะเสร็จสมบูรณ์ทั้งหมด',
  noti_monetary_scoring_privilege: 'คำนวณจากข้อมูลมูลค่าคะแนนสะสมที่ใช้แลก โดยคิดจากประวัติการทำรายการสิทธิพิศษสถานะเสร็จสมบูรณ์ทั้งหมด',
  rfm_summary: 'สรุปผลข้อมูล RFM',
  des_rfm_summary: 'สรุปการวิเคราะห์ข้อมูลพฤติกรรมเชิงลึกผ่านโมเดล RFM',
  empty_label: 'ไม่มีข้อมูล',
  equals: 'เท่ากับ',
  not_equals: 'ไม่เท่ากับ',
  greater_than: 'มากกว่า',
  less_than: 'น้อยกว่า',
  is_in_list: 'อยู่ในรายการ',
  is_not_in_list: 'ไม่อยู่ในรายการ',
  is_empty: 'ไม่มีข้อมูล',
  is_not_empty: 'มีข้อมูล',
  between: 'อยู่ระหว่าง',
  weighted: 'น้ำหนัก',
  score: 'คะแนน',
  is_over_limit: 'ค่าทั้งสามช่องรวมกันแล้วต้องไม่เกินหรือต่ำกว่า 100%',
  pos_transaction: 'รายการธุรกรรมบนPOS',
  point_transactions: 'รายการคะแนนสะสม',
  survey: 'แบบสอบถาม',
  customer_id: 'รหัสลูกค้า',
  bill_date: 'วันที่ทำรายการ',
  order_id: 'รหัสอ้างอิงคำสั่งซื้อ',
  net_amount: 'ยอดรวมสุทธิ',
  bill_status: 'สถานะบิล',
  recency_distribution: 'การกระจายตัวตามความล่าสุดของการใช้บริการ',
  frequency_distribution: 'การกระจายตัวตามความถี่ในการใช้บริการ',
  monetary_distribution: 'การกระจายตัวตามมูลค่าการใช้จ่าย',
  confirm_change_summary_mode: 'ต้องการสรุปการวิเคราะห์ใหม่?',
  des_confirm_change_summary_mode: 'หากเปลี่ยนมุมมองการสรุปวิเคราะห์ \n การจัดกลุ่มลูกค้าจะถูกรีเซต',
  mode: 'โหมด',
  is: 'คือ',
  no_conditions_saved_yet: 'ไม่มีเงื่อนไข',
  run_campaign: 'กำลังดำเนินการแคมเปญ...',
  greater_than_or_equal: 'มากกว่าหรือเท่ากับ',
  less_than_or_equal: 'น้อยกว่าหรือเท่ากับ',
  data_type: 'ประเภทข้อมูล',
  notice: 'หมายเหตุ',
  warning_error: 'ช่วงคะแนนไม่ถูกต้อง กรุณากรอกค่าที่ต่อเนื่องและไม่ซ้อนทับกัน',
  uploading_data: 'กำลังอัปโหลดข้อมูล',
};
